module.exports = __webpack_public_path__ + "static/media/location.94198bd0.svg";